<template>
	<div>
		<loader :is-visible="isLoading"></loader>
		<div class="container">
			<h1>Filosofi Logo</h1>
			<div class="container-form">
				<div class="section">
					<p>Upload Image</p>
					<input id="assetUpload" type="file" accept="image/*" @change="onAddFile($event)" hidden> 
					<div class="mg-top1">
						<img class="imgUpload" v-if="assetImgUrl" :src="assetImgUrl" alt="">
						<button class="btn-upload mg-top1 mg-right" @click="chooseFiles()">Choose</button>
					</div>
					<div class="wrapper">
						<div class="input-data mg-top">
							<input type="text" required v-model="title">
							<div class="underline"></div>
							<label>Title</label>
						</div>
						<p>*Notes <span style="color:red">Gunakan "###" untuk pemisah warna tulisan</span> ex: <span style="color:blue">Partai</span> ### <span style="color:red">Perindo</span></p>
						<div class="mg-top">
							<label  style="font-weight: bold">Description</label>
							<quill-editor
								v-model="description"
								:options="editorOption"
								@change="onEditorChange($event)"
							/>
						</div>
					</div>
				</div>

				<div class="btn-heading">
					<p class="mg-top" v-if="errors.length">
						<b>Please correct the following error(s):</b>
						<ul>
								<li class="red" v-for="(error,index) in errors" :key="index">{{ error }}</li>
						</ul>
					</p>

					<div class="mg-top1">
						<button v-if="id" class="hov-del btn-add mg-right" @click="delData()">
								Delete 
						</button>
						<button class="btn-add"  @click="validation(id != 0 ? 'update' : 'add')">
								<!-- Add Post -->
								{{id != 0? 'Update' : 'Add'}} Post
						</button>
					</div>
				</div>   
			</div>
		</div>
	</div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import axios from 'axios';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
import moment from 'moment';

import auth from '@/service/auth.js'

export default {
	name: "TentangLogo",
	data() {
		return {
			id: '',
			isLoading: false,
			assetImage: null,
			assetImgUrl : null,
			title: '',
			description: '',

			errors: [],
			editorOption: {},
		}
	},
	methods: {
		convert(val) {
			let config = { inlineStyles: true }
			let converter = new QuillDeltaToHtmlConverter(val.ops, config)
			let html = converter.convert()
			this.descConvert = html
		},
		onEditorChange({ quill}) {
			this.convert(quill.editor.delta)
		},
		onAddFile (e) {
			let splitName = e.target.files[0].name.split('.')
			let nameTemp = ''
			let typeFile = ''

			splitName.forEach((item, index) => {
					if (index == 0) {
							nameTemp = item
					} else if (index+1 != splitName.length) {
							nameTemp = nameTemp + '.' + item
					} else if (index+1 == splitName.length) {
							typeFile = '.' + item
					}
			});

			let date = moment().format('DD-MM-YYYY hh:mm:ss')
			let newName = `${nameTemp} ${date}${typeFile}`
			const myNewFile = new File([e.target.files[0]], newName, {type: e.target.files[0].type});

			this.assetImage = myNewFile
			this.assetImgUrl = URL.createObjectURL(this.assetImage)
		},
		chooseFiles() {
			document.getElementById("assetUpload").click()
		},
		validation(type) {
			this.errors = []
			
			if (!this.title) this.errors.push('* Title required')
			if (!this.description) this.errors.push('* Description required')
			
			if (this.errors.length > 0) {
					return
			} else if (type === 'add') {
					this.addData()
			} else if (type === 'update') {
					this.updateData()
			}
		},
		async addData() {
			const res = await auth.checkAuth(this.$route.fullPath)
			if (res == false) {
					localStorage.clear()
					alert.failed('Unauthorized Token', () => this.$router.push('/login'))
			} else {
				try {
					this.isLoading = true
					const formData = new FormData()

					formData.append('type', 'logo')
					formData.append('asset_type', 'picture')
					formData.append('asset', this.assetImage)
					formData.append('title', this.title)
					formData.append('description', this.descConvert)

					const response = await axios.post('/content/about', formData)
					this.isLoading = false

					console.log(response)
					if(response.status == 200) {
						alert.success('Add data success')
					}

				} catch (error) {
					console.log(error)
					this.isLoading = false
					alert.failed('Add data failed')
				}
			}
		},
		async updateData() {
			const res = await auth.checkAuth(this.$route.fullPath)
			if (res == false) {
					localStorage.clear()
					alert.failed('Unauthorized Token', () => this.$router.push('/login'))
			} else {
				try {
					this.isLoading = true
					const formData = new FormData()

					formData.append('type', 'logo')
					formData.append('asset_type', 'picture')
					formData.append('asset', this.assetImage)
					formData.append('title', this.title)
					formData.append('description', this.descConvert)

					const response = await axios.patch('/content/about/logo', formData)
					this.isLoading = false

					console.log(response)
					if(response.status == 200) {
						alert.success('Update data success')
					}

				} catch (error) {
					console.log(error)
					alert.failed('Update data failed')
				}
			}
		},
		async getData() {
			this.isLoading = true
			try {
				const response = await axios.get('/content/about', {
					params: {
						type: 'logo'
					}
				})
				console.log(response)

				this.id = response.data.about_id
				this.title = response.data.title
				this.subtitle = response.data.subtitle.String
				this.assetImage = response.data.asset
				this.assetImgUrl = response.data.asset.String
				this.description = response.data.description

				this.isLoading = false

			} catch (error) {
				 console.log(error)
        this.isLoading = false
			}
		},
		async delData() {
				let self = this
				alert.confirmation( async function () {
				self.isLoading = true
				try {
					const response = await axios.delete(`/content/about/logo`)
					self.isLoading = false
					console.log(response)
					alert.success('Delete data success', () => self.resetData())
				} catch (error) {
					self.isLoading = false
					console.log(error)
					alert.failed('Delete data failed')
				}
			}, 'Are you sure to delete it?')
		},
		resetData() {
			this.id = ''
			this.assetImage = ''
			this.assetImgUrl = ''
			this.title = ''
			this.description = ''
		},
	},
	computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
	},
	components: {
    Loader
  },
  async created () {
    const res = await auth.checkAuth(this.$route.fullPath)
    if (res == false) {
      localStorage.clear()
      this.$router.push('/login')  
    }
		this.getData()
  }
}
</script>